import React, { useState } from 'react'
import { Button, message } from 'antd'
import { saveAs } from 'file-saver'
import * as Sentry from '@sentry/react'
import { useSelector } from 'react-redux'
import { buildCsvString } from 'src/utils/csv'

const OrderedProductsCSV = ({ loadData, disabled }) => {
  const { title } = useSelector(state => state.venue.venue)
  const filter = useSelector(state => state.filter?.orders || {})

  const [isDownloading, setIsDownloading] = useState(false)

  const download = async () => {
    setIsDownloading(true)
    try {
      const data = await loadData()
      const rows = []
      rows.push([`Ordered products for ${title}`])
      rows.push([
        `Order dates: ${filter.startDate || ''} to ${filter.endDate || ''}`,
      ])
      rows.push([
        'Qty = ordered quantity; Price = received unit price or order fallback; Net/Gross = received spend ex/inc VAT.',
      ])
      rows.push([
        'Unreceipted lines use order values. Received pricing quantity uses billable weight for weight-priced items. Invoice values are not included. Missing historical prices may use current catalogue prices.',
      ])
      rows.push([])
      rows.push([
        'Product',
        'Qty',
        'Size',
        'Price',
        'Supplier',
        'SKU',
        'VAT',
        'Net',
        'Gross',
        'PO Number',
        'Order Date',
        'Pricing Unit',
        'Received Pricing Quantity / Weight',
        'Ordered Unit Price ex VAT',
        'Ordered Value ex VAT',
        'Receipt Status',
      ])

      data?.forEach(row => {
        const productTitle = row?.product?.title ?? 'N/A'
        const quantity = row?.quantity ?? ''
        const size = row?.product?.size ?? 'N/A'
        const priceNumber = Number(row?.price)
        const priceFormatted = !isNaN(priceNumber)
          ? `£${priceNumber.toFixed(2)}${row?.product?.hasVat ? ' + VAT' : ''}`
          : `${row?.price ?? ''}`
        const supplierTitle =
          row?.supplierTitle ?? row?.product?.supplier?.title ?? 'N/A'
        const sku = row?.product?.sku ?? ''
        const vat = row?.totalVat ?? ''
        const net = row?.netTotal ?? ''
        const gross = row?.grossTotal ?? ''

        rows.push([
          productTitle,
          quantity,
          size,
          priceFormatted,
          supplierTitle,
          sku,
          vat,
          net,
          gross,
          row.purchaseOrderNumber ?? '',
          row.orderedDate ? String(row.orderedDate).slice(0, 10) : '',
          row.pricingUnit ?? '',
          row.receivedQty ?? '',
          row.orderedUnitPrice ?? '',
          row.orderedValue == null ? '' : Number(row.orderedValue).toFixed(2),
          row.receipting?.status ?? 'Unreceipted',
        ])
      })

      const csvString = buildCsvString(rows)
      saveAs(
        new Blob([csvString], { type: 'text/csv;charset=utf-8;' }),
        `oms-ordered-products_${title}.csv`,
      )
    } catch (error) {
      Sentry.captureException(error)
      message.error('Unable to download ordered products. Please try again.')
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <Button
      style={{ marginRight: '10px' }}
      onClick={download}
      loading={isDownloading}
      disabled={disabled || isDownloading}
    >
      Download CSV
    </Button>
  )
}

export default OrderedProductsCSV
